import axios from "axios";
import moment from "moment";

export const getAssignedBookingsAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/affiliates/assignedBookings?pageNumber=${payload?.pageNumber}`,
    {
      headers: {
        Authorization: `${payload?.token}`,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const bookingDetailAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/affiliates/bookingDetails?bookingId=${payload.bookingId}`,
    {
      headers: {
        Authorization: `${payload.token}`,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const assignDriverAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/bookings/assignDriver`,
    payload.body,
    {
      headers: {
        Authorization: `${payload.token}`,
      },
      withCredentials: true,
    }
  );

  return response;
};

export const totalAffiliateBokingAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/affiliates/totalAffiliateBookingCount`,
      {
        headers: {
          Authorization: payload,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const affiliateFilterAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/affiliates/filterAffiliate?affiliateId=${payload.affiliateId}&searchQuery=${payload.searchItem}`,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const affiliateFilterCompleteAction = async (payload) => {
  let singleDate = null;
  let startDate = null;
  let endDate = null;

  if (payload?.singleDate) {
    singleDate = moment(payload?.singleDate)?.format("YYYY-MM-DD");
  }
  if (payload?.startDate) {
    startDate = moment(payload?.startDate)?.format("YYYY-MM-DD");
  }
  if (payload?.endDate) {
    endDate = moment(payload?.endDate)?.format("YYYY-MM-DD");
  }
  try {
    let URL = `${process.env.REACT_APP_BASE_URL}/affiliates/filterCompleteAffiliate?`;
    let BODY = {};

    if (payload?.affiliateId?.trim()) {
      URL = URL + `affiliateId=${payload.affiliateId}&`;
    }
    if (payload.passengerName?.trim()) {
      URL = URL + `passengerName=${payload.passengerName}&`;
    }
    if (payload.driverName?.trim()) {
      URL = URL + `driverName=${payload.driverName}&`;
    }
    if (payload.bookingId?.trim()) {
      URL = URL + `bookingId=${payload.bookingId}&`;
    }
    if (payload.singleDate) {
      URL = URL + `singleDate=${singleDate}`;
    }

    // When Start Date is present but not End Date
    if (startDate) {
      BODY.travelStartDate = startDate;
      if (!endDate && !singleDate) {
        URL = URL + `singleDate=${startDate}`;
        BODY = {};
      }
    }

    // When End Date is present but not Start Date
    if (endDate) {
      BODY.travelEndDate = endDate;
      if (!startDate && !singleDate) {
        URL = URL + `singleDate=${endDate}`;
        BODY = {};
      }
    }

    // When Start Date and End Date is Equal
    if (startDate && endDate && startDate === endDate) {
      URL = URL + `singleDate=${startDate}`;
      BODY = {};
    }

    const response = await axios.post(URL, BODY, {
      headers: {
        "Content-Type": "application/json",
        Authorization: payload.token,
      },
    });
    console.log("response         ------------> ", response);
    return response;
  } catch (error) {
    console.log(error);
  }
};
